export default "__VITE_ASSET__2d4Z9khl__"